import * as Sentry from '@sentry/react'
import {
  buildSentryOptions,
  RESTRICTIVE_DATA_COLLECTION,
  type SentryApp,
  type SentryDeployMode,
} from '@zealth/core/sentry'

export type WebSentryApp = Extract<SentryApp, 'portal' | 'playground'>

export function initSentry(app: WebSentryApp): void {
  const options = buildSentryOptions({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
    release: import.meta.env.VITE_SENTRY_RELEASE,
    app,
    deployMode: import.meta.env.VITE_SENTRY_DEPLOY_MODE as
      SentryDeployMode | undefined,
  })
  if (!options) return
  Sentry.init({ ...options, dataCollection: RESTRICTIVE_DATA_COLLECTION })
}

export { Sentry }
